import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import InstituteForm from 'components/institute/InstituteForm';
import { changePasswordRequest } from 'services/auth';
import { encryptPassword } from 'utils';
import Breadcrumb from 'components/ui/Breadcrumb';
import ChangePasswordForm from '../../../components/auth/ChangePasswordForm';
import UserProfileForm from '../../../components/auth/UserProfileForm';
import { getUserProfile, updateUserProfileRequest } from '../../../services/user';
import appUrls from '../../../appUrls';
import { useDispatch } from 'react-redux';
import { getProfile } from '../../../store/slices/authSlice';

const useStyles = makeStyles((theme) => ({
    mainHeading: {
        margin: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            textAlign: 'center'
        }
    },
    breadcrumbs: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center'
        }
    }
}));

function UserProfilePage(props) {
    const classes = useStyles();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [profileDetails, setProfileDetails] = useState();
    const [profileDetailsLoading, setProfileDetailsLoading] = useState(true);

    useEffect(() => {
        async function fetchUserProfile() {
            setProfileDetailsLoading(true);
            const result = await getUserProfile();
            if (result.error === false) {
                const userData = {
                    userId: result.user._id,
                    contactNumber: result.user.contactNumber,
                    name: result.user.name,
                    image: { url: '', key: '', new: false, loading: false }
                };
                if (result?.user?.image) {
                    userData.image = { url: `${result.imageBaseUrl}/${result?.user?.image}`, key: '', new: false, loading: false };
                } else {
                    userData.image = { url: '', key: '', new: false, loading: false };
                }
                setProfileDetails(userData);
            }
            setProfileDetailsLoading(false);
            console.log('-> result', result);
        }
        fetchUserProfile();
    }, []);

    const handleUpdateForm = async (values, { resetForm, setSubmitting }) => {
        setSubmitting(true);
        const { name, contactNumber, image, userId } = values;
        const response = await updateUserProfileRequest({
            name,
            contactNumber: contactNumber ?? null,
            image: image?.new ? image.key : image.url,
            userId
        });
        if (response.error === false) {
            dispatch(getProfile());
            navigate(appUrls.PROFILE);
        }
        setSubmitting(false);
    };

    return (
        <>
            <Breadcrumb title="Profile" />
            <Grid container justifyContent="center">
                <Grid item xs={12} lg={11} xl={9}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Box p={1}>
                                        {profileDetailsLoading || (
                                            <UserProfileForm handleSubmit={handleUpdateForm} initialValues={profileDetails} />
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default UserProfilePage;
